import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const OpenExternalIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 23.93 24",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 24),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.83 13.05 10.9-10.89"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.2 5h-5.87a1.24 1.24 0 0 0 -1.33 1.18v14.99c0 1.38.7 1.83 1.64 1.83h14.78c1.08 0 1.58-.32 1.58-1.5v-6.16"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.93 1h6v6"
    })]
  });
};

export { OpenExternalIcon };
//# sourceMappingURL=open.external.js.map
